import styled from 'styled-components';

const Textarea = styled.textarea`
  border: 1px solid #E5E5E5;
  border-radius: 10px;
  min-height: 100px;
  padding: 1rem;
  box-sizing: border-box;
`;

export default Textarea;